<template>
  <div class="my-6">
    <NuxtLink
      :to="localizedHref"
      :external="isExternal"
      :target="isExternal ? '_blank' : undefined"
      :rel="isExternal ? 'noopener noreferrer' : undefined"
      class="inline-flex items-center gap-2 px-5 py-2.5 min-h-[44px] bg-primary text-primary-foreground font-medium rounded-lg hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 transition-colors"
    >
      <slot />
      <template v-if="isExternal">
        <Icon name="tabler:external-link" size="16" aria-hidden="true" />
        <span class="sr-only">(opens in new tab)</span>
      </template>
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
/**
 * Blog CTA (Call-to-Action) Component
 *
 * A styled button component for MDC (Markdown Components) that creates
 * prominent call-to-action links in blog content.
 * Usage in markdown: ::blog-cta{href="/contact"}
 */

interface Props {
  /**
   * The URL to link to
   */
  href: string;
}

const props = defineProps<Props>();

// Check if link is external
const isExternal = computed(() => {
  return props.href.startsWith('http') || props.href.startsWith('//');
});

// Get localized path for internal links
const localizedHref = computed(() => {
  return isExternal.value ? props.href : props.href;
});
</script>
